<template lang="html">
  <component :is="tag" class="session-moves-stats">
    Correct moves: {{ sessionMovesCorrect }}/{{ sessionMovesTotal }} (<b
      >{{ sessionMovesCorrectPercentage }}%</b
    >)
  </component>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SessionMovesStats',

  props: {
    tag: {
      type: String,
      default: 'section',
    },
  },

  computed: {
    ...mapState(['sessionMovesCorrect', 'sessionMovesTotal']),
    ...mapGetters(['sessionMovesCorrectPercentage']),
  },
};
</script>
